function HandwriteSignature(firstAndLast, duration = 2000) {
    if (!firstAndLast || !firstAndLast.trim()) {
        return; 
    }

    new Vara(
        "#vara-container",
        "https://cdn.jsdelivr.net/npm/vara@1.4.0/fonts/Satisfy/SatisfySL.json",
        [{
            text: firstAndLast,
            fontSize: 30,
            duration: duration,
            strokeWidth: 1.5,
            textAlign: "center",
        }]
    );
}